export const cursos = [{
    id: "1",
    urlImg: "/cursos/PROGRAMACION.jpg",
    descBreve: 'Domina la lógica de programación',
    titulo: "Lógica de programación",
    dias: ["MA", "MI", "VI"],
    hInicioFin: ["18:00", "21:00"],
    fInicioFin: ["14/12/2020", "31/12/2020"],
    urlInscripcion:
        "https://docs.google.com/forms/d/1289uM5HpQJayebidAjXonLi8sCg_hT6wzPXCVfpMvD8/edit",
    excepciones: ["17/12/2020"],
    cancelaciones: [],
    descExtendida: 'Descripción extendida',
    requisitos: [
        "Saber Javascript",
        "Saber ES6"
    ],
    objetivo: "Lograr convertirse en un experto en programación",
    idProfesor: "DW-01"
}, {
    id: "2",
    urlImg: "/cursos/FLUTTER.jpg",
    descBreve: "Domina la programación orientada a objetos con Java",
    titulo: "Flutter: 1 proyecto por semana",
    dias: ["SA"],
    hInicioFin: ["18:00", "22:00"],
    fInicioFin: ["13/12/2020", "01/06/2021"],
    excepciones: [],
    cancelaciones: [],
    urlInscripcion:
        "https://docs.google.com/forms/d/1JyyoqGonX-P1ex4Ly4cmvK7JF-8cPcgzCEg5hDXVZSM/edit",
    descExtendida: 'Descripción extendida',
    requisitos: [
        "Ninguno"
    ],
    objetivo: "Lograr convertirse en un experto en Flutter",
    idProfesor: "RCT-001"
},
{
    id: "4",
    urlImg: "/cursos/C-CSHARP.jpg",
    descBreve: "Domina C# desde cero",
    titulo: "C# - básico",
    dias: ["SA"],
    hInicioFin: ["20:00", "21:00"],
    fInicioFin: ["13/12/2020", "01/06/2021"],
    excepciones: ["13/12/2020"],
    cancelaciones: [],
    urlInscripcion:
        "https://docs.google.com/forms/d/1QYA9iQ8AJVQ-aKpNM4ulWa_hC6Yw8L7M2zNLPK_xG-U/edit",
    descExtendida: 'Descripción extendida',
    requisitos: [
        "Ninguno",
    ],
    objetivo: "Lograr convertirse en un experto en C#",
    idProfesor: "CCC-B01",
},
{
    id: "5",
    urlImg: "/cursos/JAVA.jpg",
    descBreve: "Domina la programación orientada a objetos con Java",
    titulo: "OOP en Java",
    dias: ["SA", "DO"],
    hInicioFin: ["22:00", "23:59"],
    fInicioFin: ["13/12/2020", "01/06/2021"],
    excepciones: [],
    cancelaciones: ["13/12/2020"],
    urlInscripcion:
        "https://docs.google.com/forms/d/1xBZP0UYxcxqZcZjpIWDl4BuFuJGbCpAL2d4jw8XdDJ0/edit",
    descExtendida: 'Descripción extendida',
    requisitos: [
        "Ninguno",
    ],
    objetivo: "Lograr convertirse en un experto en C#",
    idProfesor: "CCC-B01"
},
{
    id: "6",
    urlImg: "/cursos/UI-UX.jpg",
    descBreve: "Domina los fundamentos de UI/UX",
    titulo: "Fundamentos de UI/UX",
    dias: ["LU", "VI"],
    hInicioFin: ["21:00", "22:30"],
    fInicioFin: ["13/12/2020", "01/06/2021"],
    excepciones: [],
    cancelaciones: [],
    urlInscripcion:
        "https://docs.google.com/forms/d/1B3lvGfBsX99Gr4sRT9DCuU1adOnuuX7BygdTLDNFNm4/edit",
    descExtendida: 'Descripción extendida',
    requisitos: [
        "Ninguno",
    ],
    objetivo: "Lograr convertirse en un experto en C#",
    idProfesor: "CCC-B01"
}
]

export const diasSemana = ["LU", "MA", "MI", "JU", "VI", "SA", "DO"];
export const nombresDiasSemana = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"];